module.exports = __webpack_public_path__ + "assets/img/img308.349ad3a7.png";